import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import UseToggle from "../../../../Hooks/UseToggle";
import SplitPane from "react-split-pane";
import LUPReportActivities from "./LUPReportActivities";
import AddNewLUPReport from "./AddNewLUPReport";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import UpdateLUPReport from "./UpdateLUPReport";
import { useParams } from "react-router";
import Pagination from "../../../Pagination";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { CiSearch } from "react-icons/ci";
import DeletedLUPReport from "./DeletedLUPReport";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";
import ReportListing from "./ReportListing";

const LUPReport = ({ onMouseDown, tableRef }) => {
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const { toggle1, setToggle1, toggle3, setToggle3 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [reportId, setReportId] = useState("");
  const [reportData, setReportData] = useState("");
  const [reportList, setReportList] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [activeTab, setActiveTab] = useState(StudyMode === "DBP Mode" ? "activities" : "generated Reports");
  const [activityLoader, setActivityLoader] = useState(false);
  const [reportActivity, setReportActivity] = useState([]);
  const [reportActivityCount, setReportActivityCount] = useState(0);
  const [reportDeletedList, setReportDeletedList] = useState([]);
  const [reportDeletedListCount, setReportDeletedListCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(reportCount / itemsPerPage);

  const getLupReportMetadatasData = async () => {
    setLoading(true)
    let data = await studyEDCLupReportingServices.getLupReportMetadatasData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    )
    setReportList(data?.data || []);
    setReportCount(data?.count || 0);
    setLoading(false)
  }

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedLupReportMetadatasData = async (pageNumberDeleted) => {
    let data = await studyEDCLupReportingServices.getLupReportMetadatasData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setReportDeletedList(data?.data || []);
    setReportDeletedListCount(data?.count || 0);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    getLupReportMetadatasData();
  }, [searchData, pageNumber, itemsPerPage]);

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyLupReportMetadata",
      studyId,
      reportId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setReportActivity(data?.data || []);
    setReportActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const softDeleteRestoreLupReportMetadata = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} report!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data =
          await studyEDCLupReportingServices.softDeleteRestoreLupReportMetadata(
            userData
          );
        if (data?.statusCode === 200) {
          setReportId("")
          getLupReportMetadatasData();
          getDeletedLupReportMetadatasData();
          if (type === "restore") {
            getDeletedLupReportMetadatasData(
              pageNumberDeleted,
              itemsPerPageDeleted
            );
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          {StudyMode === "DBP Mode" &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New Report"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setReportId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          }
          {reportCount > 0 &&
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          }
        </div>
        {reportDeletedListCount > 0 &&
          <button
            onClick={() => {
              setToggle1();
              getDeletedLupReportMetadatasData(
                pageNumberDeleted,
                itemsPerPageDeleted
              );
            }}
            className={`updateProfile`}
          >
            Deleted History
          </button>
        }
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 184px)" }}
        minSize={reportId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewLUPReport getLupReportMetadatasData={getLupReportMetadatasData} />
          )}
          {loading ? (
            <PageLoader />
          ) : reportCount === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG="Report list not found" />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Report Number</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Report Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Report Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Report Description</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>
                      Last Updated Date |  Time
                    </th>
                    {StudyMode === "DBP Mode" &&
                      <>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 6)}
                          style={{ width: 45 }}
                          className="text-center"
                        >
                          Edit
                        </th>
                        <th
                          onMouseDown={(e) => onMouseDown(e, 7)}
                          style={{ width: 45 }}
                          className="text-center"
                        >
                          Delete
                        </th>
                      </>
                    }
                  </tr>
                </thead>
                <tbody>
                  {reportList?.map((item, index) => (
                    <tr
                      key={item?._id || index}
                      className={`CP ${reportId === item?.reportId ? "highlighted" : ""}`}
                      title="View Details"
                      onClick={() => {
                        setReportData(item);
                        setReportId(item?.reportId);
                        setIsFormOpen(false);
                      }}
                    >
                      <td className="text-center">{index + 1 + startIndex}</td>
                      <td>{item?.reportNumber}</td>
                      <td>{item?.reportName}</td>
                      <td>{item?.reportTypeName}</td>
                      <td>{item?.reportDescription}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item?.updatedAt}
                        </Moment>
                      </td>
                      {StudyMode === "DBP Mode" &&
                        <>
                          <td
                            className="text-center"
                            title={`Update ${item?.reportName}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              setReportData(item);
                              setToggle3();
                            }}
                          >
                            <FaEdit />
                          </td>
                          <td
                            className="text-center"
                            title={`Delete ${item?.reportName}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              softDeleteRestoreLupReportMetadata(item?._id, "delete");
                            }}
                          >
                            <FaTrash className="text-danger" />
                          </td>
                        </>
                      }
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={reportCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {reportId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {(StudyMode === "DBP Mode" ? ["activities", "generated Reports"] : ["generated Reports"]).map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""}`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setReportId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <LUPReportActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                reportActivity={reportActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                reportData={reportData}
                reportActivityCount={reportActivityCount}
              />
            )}
            {activeTab === "generated Reports" && (
              <ReportListing
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                ids={reportData}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateLUPReport
        Show={!toggle3}
        Hide={setToggle3}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Update Report"}
        reportData={reportData}
        setReportData={setReportData}
        setReportId={setReportId}
        getLupReportMetadatasData={getLupReportMetadatasData}
      />
      <DeletedLUPReport
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        reportDeletedList={reportDeletedList}
        getDeletedLupReportMetadatasData={getDeletedLupReportMetadatasData}
        reportDeletedListCount={reportDeletedListCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreLupReportMetadata={softDeleteRestoreLupReportMetadata}
        Title={"Deleted Report Metadata History"}
      />
    </>
  );
};

export default LUPReport;
